module.exports = __webpack_public_path__ + "assets/img/horizontal.dee2d473.png";